'use client';
import type React from 'react';
import type { JSX } from 'react';

import OptimizedImage from './OptimizedImage';
import type { ImageFetchPriority, ImageLoading } from './types';

interface SquareImageProps {
    src: string;
    alt: string;
    size?: number;
    enforceBypassNextImage?: boolean;
    className?: string;
    style?: React.CSSProperties;
    quality?: number;
    onError?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
    loading?: ImageLoading;
    fetchPriority?: ImageFetchPriority;
}

const SquareImage = ({
    src,
    alt,
    size = 48,
    enforceBypassNextImage = false,
    className,
    style,
    quality,
    onError,
    loading = 'lazy',
    fetchPriority = 'auto',
}: SquareImageProps): JSX.Element => (
    <OptimizedImage
        src={src}
        width={size}
        height={size}
        alt={alt}
        enforceBypassNextImage={enforceBypassNextImage}
        className={className}
        style={style}
        quality={quality}
        onError={onError}
        loading={loading}
        fetchPriority={fetchPriority}
    />
);

export default SquareImage;
